<template>
  <div v-loading="loading" class="app-container">
    <el-card class="mb10">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="" class="numberSearch">
              <template slot="label">
                <el-select v-model="type1" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                  <!-- 发票密钥 -->
                  <el-option :label="$t('mdfeTranslate.InvoiceSecretKey')" value="invoiceKeyList" />
                  <!-- 业务单号 -->
                  <el-option :label="$t('receivablePayable.TicketNumber')" value="businessNumberList" />
                  <!-- 发票号码 -->
                  <el-option :label="$t('basicData.InvoiceNumber')" value="invoiceNumberList" />
                </el-select>
              </template>
              <InputTextareaCmp
                ref="inputTextareaRef"
                :val="listVal"
                :max-length="2000"
                :min-rows="5"
                @input="(_, val) => listVal = val"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-row :gutter="10">
              <el-col :span="12">
                <!-- 开票时间 -->
                <el-form-item :label="$t('GlobalSetObj.InvoicingTime')">
                  <el-date-picker
                    v-model="queryForm.params.invoiceIssueTime"
                    type="datetimerange"
                    range-separator="-"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :start-placeholder="$t('GlobalSetObj.startDate')"
                    :end-placeholder="$t('GlobalSetObj.endDate')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 业务类型 -->
                <el-form-item :label="$t('collectionCenter.businessT')">
                  <el-select
                    v-model="queryForm.params.businessType"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    style="width: 100%;"
                  >
                    <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                    <el-option
                      v-for="item in BUSINESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 发票状态 -->
                <el-form-item :label="$t('basicData.InvoiceStatus')">
                  <el-select
                    v-model="queryForm.params.statusList"
                    :placeholder="$t('collectionCenter.tudo')"
                    multiple
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in INVOICE_STATUS"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--  客户  -->
                <el-form-item :label="$t('GlobalSetObj.client')">
                  <el-select
                    v-model="queryForm.params.customerId"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    :remote-method="getCustomerPage"
                    clearable
                    filterable
                    remote
                    reserve-keyword
                    style="width: 100%"
                    @visible-change="getCustomerPage()"
                  >
                    <el-option
                      v-for="item in customerList"
                      :key="item.id"
                      :label="item.customerAlias + '（' + item.username + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div style="margin-top: 28px;">
                  <!--查询-->
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    @click="search"
                  >{{ $t('basicData.Search') }}
                  </el-button>
                  <!--重置-->
                  <el-button
                    icon="el-icon-refresh"
                    size="mini"
                    @click="onReset"
                  >{{ $t('basicData.reset') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div class="mb10">
        <!-- 批量下载 -->
        <el-popover
          v-permit:remove="'btn:invoiceCenter:etc-bulkDownload'"
          placement="bottom"
          trigger="hover"
        >
          <div>
            <div style="margin-bottom: 10px;">
              <!--勾选下载-->
              <el-button
                size="small"
                type="primary"
                :disabled="multipleSelection.length === 0"
                @click="bulkDownload"
              >{{ $t('mdfeTranslate.CheckDownload') }}</el-button>
            </div>
            <div>
              <!--按号码下载-->
              <el-button
                size="small"
                type="primary"
                @click="orderNumberDownload"
              >{{ $t('mdfeTranslate.DownloadByNumber') }}</el-button>
            </div>
          </div>
          <el-button slot="reference" size="small" style="margin-right: 10px;">{{ $t('orderCenterCont.BulkDownload') }}</el-button>
        </el-popover>
        <!-- 导出 -->
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-onExport'"
          size="small" type="primary" @click="onExport"
        >{{ $t('CenterForSorting.export') }}</el-button>
        <!-- 导出NFSe发票 -->
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-NFSeInvoiceExport'"
          size="small" type="primary" @click="exportNFSeInvoice"
        >{{ $t('mdfeTranslate.ExportNFSeInvoice') }}</el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-onExportOrderNumber'"
          size="small"
          type="primary"
          @click="onExportusinessOrderNumberInvoiceNumber"
        >
          <!--按业务单号或发票号导出-->
          {{ $t('mdfeTranslate.ExportByInvoiceKeyOrBusinessOrderNumber') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-reopenCteInvoiceShow'"
          size="small"
          type="primary"
          @click="reopenCteInvoiceShow"
        >
          <!--补开cte发票-->
          {{ $t('mdfeTranslate.ReopenCteInvoice') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-cancelInvoice'"
          size="small"
          type="primary"
          :disabled="multipleSelection.length === 0 || multipleSelection.length > 1"
          @click="openCancelInvoiceWindow(1)"
        >
          <!--取消发票-->
          {{ $t('GlobalSetObj.CancelTheInvoice') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-batchCancelInvoice'"
          size="small"
          type="primary"
          @click="openCancelInvoiceWindow(2)"
        >
          <!--批量取消发票-->
          {{ $t('mdfeTranslate.BatchCancelInvoice') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:invoiceCenter:etc-newCteInvoiceShow'"
          size="small"
          type="primary"
          @click="newCteInvoiceShow"
        >
          <!--补开cte发票-->
          {{ $t('mdfeTranslate.NewCteInvoice') }}
        </el-button>
      </div>

      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />
        <!-- 开票时间 -->
        <el-table-column prop="invoiceDate" :label="$t('GlobalSetObj.InvoicingTime')" min-width="160" />
        <!-- 业务类型 -->
        <el-table-column prop="businessTypeName" :label="$t('collectionCenter.businessT')" min-width="100" />
        <!-- 发票号码 -->
        <el-table-column prop="invoiceNumber" :label="$t('basicData.InvoiceNumber')" min-width="160">
          <template v-slot="scope">
            <el-popover
              placement="top-end"
              popper-class="copy"
              trigger="hover"
            >
              <!--复制-->
              <el-button type="text" @click="copy(scope.row.invoiceNumber)">{{ $t('orderDetails.copy') }}</el-button>
              <span slot="reference" style="color: #409eff;cursor: pointer;" @click="checkDetail(scope.row)">{{ scope.row.invoiceNumber }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <!-- 发票密钥 -->
        <el-table-column prop="invoiceKey" :label="$t('newOrder.InvoiceKey')" min-width="380">
          <template v-slot="scope">
            <el-popover
              placement="top-end"
              popper-class="copy"
              trigger="hover"
            >
              <!--复制-->
              <el-button type="text" @click="copy(scope.row.invoiceKey)">{{ $t('orderDetails.copy') }}</el-button>
              <span slot="reference" style="color: #409eff;cursor: pointer;" @click="downloadXml(scope.row)">{{ scope.row.invoiceKey }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <!-- 业务单号 -->
        <el-table-column prop="businessNumber" :label="$t('receivablePayable.TicketNumber')" min-width="220" />
        <!-- 运单号 -->
        <el-table-column prop="waybillNumber" :label="$t('GlobalSetObj.waybillNumber')" min-width="220" />
        <!-- 开票主体 -->
        <el-table-column prop="payerName" :label="$t('basicData.BillingBody')" min-width="160" />
        <!-- 开票主体CNPJ -->
        <el-table-column prop="payerTaxId" :label="$t('basicData.BillingBody') + 'CNPJ'" min-width="160" />
        <!-- 状态 -->
        <el-table-column prop="statusName" :label="$t('GlobalSetObj.status')" min-width="120" />
        <!-- 发票总金额 -->
        <el-table-column prop="invoiceTotalAmount" :label="$t('receivablePayable.totalInvoiceAmount')" min-width="160">
          <template v-slot="scope">
            <div>{{ formatNumber(scope.row.invoiceTotalAmount) }}</div>
          </template>
        </el-table-column>
        <!-- ICMS金额 -->
        <el-table-column prop="icmsAmount" :label="$t('receivablePayable.ICMSAmount')" min-width="160">
          <template v-slot="scope">
            <div>{{ formatNumber(scope.row.icmsAmount) }}</div>
          </template>
        </el-table-column>
        <!-- 运费金额(不含税) -->
        <el-table-column prop="freightAmount" :label="$t('mdfeTranslate.FreightAmountNoTax')" min-width="160">
          <template v-slot="scope">
            <div>{{ formatNumber(scope.row.freightAmount) }}</div>
          </template>
        </el-table-column>
        <!-- 运费金额(含税) -->
        <el-table-column prop="freightAmountInclTax" :label="$t('mdfeTranslate.FreightAmountTax')" min-width="160">
          <template v-slot="scope">
            <div>{{ formatNumber(scope.row.freightAmountInclTax) }}</div>
          </template>
        </el-table-column>
        <!-- 从价税 -->
        <el-table-column prop="adValoremTax" :label="$t('basicData.AdValoremTax')" min-width="160">
          <template v-slot="scope">
            <div>{{ formatNumber(scope.row.adValoremTax) }}</div>
          </template>
        </el-table-column>
        <!-- 保险费 -->
        <el-table-column prop="insuranceFee" :label="$t('basicData.insurance')" min-width="160">
          <template v-slot="scope">
            <div>{{ formatNumber(scope.row.insuranceFee) }}</div>
          </template>
        </el-table-column>
        <!-- 保单批号 -->
        <el-table-column prop="averbNumber" :label="$t('mdfeTranslate.PolicyBatchNumber')" min-width="160" />
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
    <!--下载pdf-->
    <el-dialog
      :title="$t('mdfeTranslate.BatchCTEPDF')"
      :visible.sync="showDownloadCtePDF"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <ctePDF :key="downloadCteXMLKey" :cte-data="cteData" :create-pdf-type="createPdfType" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDownloadCtePDF = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--  按业务单号或发票号导出  -->
    <ExportusinessOrderNumberInvoiceNumberCmp ref="exportusinessOrderNumberInvoiceNumberRef" />
    <!--补开cte发票-->
    <el-dialog
      :title="$t('mdfeTranslate.cteReopen')"
      :visible.sync="showReopenCteInvoiceWindow"
      width="700px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <reopenCteInvoice
          ref="reopenCteInvoiceData"
          :key="reopenCteInvoiceKey"
          :multiple-selection="multipleSelection"
          @closeWindow="closeWindow"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showReopenCteInvoiceWindow = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmSaveData">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--单个取消发票-->
    <el-dialog
      :title="$t('GlobalSetObj.CancelTheInvoice')"
      :visible.sync="showSingleCancelInvoice"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
      @close="closeSingleCancelInvoice"
    >
      <div>
        <el-form
          ref="cancelInvoiceForm"
          :model="cancelInvoiceForm"
          label-position="top"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$t('mdfeTranslate.PackageNumber') + '：'">
                <span>{{ cancelInvoiceForm.packageNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('mdfeTranslate.InvoiceSecretKey') + '：'">
                <span>{{ cancelInvoiceForm.invoiceKey }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('mdfeTranslate.CancellationReasonType') + '：'"
                prop="cancelReasonType"
                :rules="{ required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }"
              >
                <el-select v-model="cancelInvoiceForm.cancelReasonType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                  <el-option key="0" :label="$t('mdfeTranslate.BillingError')" :value="1" /><!--计费错误-->
                  <el-option key="1" :label="$t('mdfeTranslate.IncorrectRule')" :value="2" /><!--规则有误-->
                  <el-option key="2" :label="$t('basicData.other')" :value="0" /><!--其他-->
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeSingleCancelInvoice">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmSingleCancelInvoice">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--批量取消发票-->
    <el-dialog
      :title="$t('mdfeTranslate.BatchCancelInvoice')"
      :visible.sync="showCancelInvoiceWindow"
      width="560px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <cancelInvoice ref="cancelInvoice" :key="showCancelInvoiceWindow" @closeCancelWindow="closeCancelWindow" />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showCancelInvoiceWindow = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmCancelInvoice">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--下载XML-->
    <el-dialog
      :title="$t('mdfeTranslate.DownloadXml')"
      :visible.sync="showDownloadXML"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div style="border-radius: 5px;border: 1px solid #ccc;padding: 10px;width: 100%;height: 500px;overflow:auto;">
        <pre>{{ rowCteData.xmlString }}</pre>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" type="primary"
          @click="confirmDownloadXML"
        >{{ $t('GlobalSetObj.Download') }}</el-button>
        <el-button size="small" @click="showDownloadXML = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <!--导出NFSe-->
    <exportNFSe ref="exportNFSe" :key="showExportNFSeInvoice" />
    <!--新开cte发票-->
    <el-dialog
      :title="$t('mdfeTranslate.NewCteInvoice')"
      :visible.sync="showNewCteInvoiceWindow"
      width="700px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <newCTEInvoiceIssued
          ref="newCteInvoiceData"
          :key="newCteInvoiceKey"
          @closeNewCTEWindow="closeNewCTEWindow"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showNewCteInvoiceWindow = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmSaveNewData">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--按号码批量下载-->
    <el-dialog
      :title="$t('mdfeTranslate.DownloadByNumber')"
      :visible.sync="showByNumberWindow"
      width="700px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
      @close="closeByNumberWindow"
    >
      <div>
        <el-form
          ref="downloadFormRef"
          :model="downloadForm"
          label-position="top"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="" class="numberSearch">
                <template slot="label">
                  <el-select v-model="downloadForm.numberType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                    <!-- 发票密钥 -->
                    <el-option :label="$t('mdfeTranslate.InvoiceSecretKey')" value="invoiceKeyList" />
                    <!-- 业务单号 -->
                    <el-option :label="$t('receivablePayable.TicketNumber')" value="businessNumberList" />
                    <!-- 发票号码 -->
                    <el-option :label="$t('basicData.InvoiceNumber')" value="invoiceNumberList" />
                  </el-select>
                </template>
                <InputTextareaCmp
                  ref="byNumberRef"
                  :val="numberStr"
                  :max-length="5000"
                  :min-rows="5"
                  @input="(_, val) => numberStr = val"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 业务类型 -->
              <el-form-item :label="$t('collectionCenter.businessT')">
                <el-select
                  v-model="downloadForm.businessType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%;"
                >
                  <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                  <el-option
                    v-for="item in BUSINESS_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showByNumberWindow = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmDownloadForm">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import reopenCteInvoice from './cmp/reopenCteInvoice.vue';
import cancelInvoice from './cmp/cancelInvoice.vue';
import exportNFSe from './cmp/exportNFSe.vue';
import newCTEInvoiceIssued from './cmp/newCTEInvoiceIssued.vue';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';
import {
  INVOICE_STATUS,
  BUSINESS_TYPE
} from './utils';
import { copyData } from '@/utils/copyData';
import {
  cancelCteInvoice,
  downloadCteXml,
  exportCteInvoice,
  getBatchDownloadCteInvoiceInfo,
  getCteInvoiceByKey,
  getCteInvoicePage
} from '@/api/invoiceCenter';
import { apiCustomerPage } from '@/api/customer';
import ctePDF from './cmp/ctePDF.vue';
import ExportusinessOrderNumberInvoiceNumberCmp
from './cmp/ExportusinessOrderNumberInvoiceNumberCmp.vue';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
import { formatNumber } from '@/utils/tools';

export default {
  name: 'Etc',

  components: {
    ExportusinessOrderNumberInvoiceNumberCmp,
    ctePDF,
    InputTextareaCmp,
    reopenCteInvoice,
    cancelInvoice,
    exportNFSe,
    newCTEInvoiceIssued
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      BUSINESS_TYPE, // 业务类型
      INVOICE_STATUS, // 发票状态
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          invoiceIssueTime: [startTime, endTime],
          customerId: null,
          businessType: null,
          invoiceKeyList: [],
          businessNumberList: [],
          statusList: []
        }
      },
      type1: 'invoiceKeyList',
      listVal: '',
      total: 0,
      tableData: [],
      multipleSelection: [], // 勾选
      loading: false,
      pickerMinDate: '',
      pickerRange: 14 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      cteData: [],
      showDownloadCtePDF: false,
      downloadCteXMLKey: new Date().getTime(),
      createPdfType: 1,
      showReopenCteInvoiceWindow: false,
      reopenCteInvoiceKey: new Date().getTime(),
      showCancelInvoiceWindow: false,
      cancelInvoiceWindowKey: new Date().getTime(),
      showSingleCancelInvoice: false,
      cancelInvoiceForm: {
        packageNo: '',
        invoiceKey: '',
        cancelReasonType: null
      },
      showDownloadXML: false,
      rowCteData: {},
      showExportNFSeInvoice: false,
      showNewCteInvoiceWindow: false,
      newCteInvoiceKey: new Date().getTime(),
      customerList: [],
      formatNumber,
      showByNumberWindow: false,
      numberStr: '',
      downloadForm: {
        businessType: null,
        numberType: 'invoiceKeyList'
      }
    };
  },
  created() {
    this.getCustomerPage();
    setTimeout(() => {
      this.getTable();
    }, 100);
  },

  methods: {
    // 打开按号码批量下载弹窗
    orderNumberDownload() {
      this.showByNumberWindow = true;
    },
    // 关闭按号码批量下载弹窗
    closeByNumberWindow() {
      this.numberStr = '';
      this.downloadForm = {
        businessType: null,
        numberType: 'invoiceKeyList'
      };
    },
    // 确定下载
    confirmDownloadForm() {
      const paran = {
        businessType: this.downloadForm.businessType,
        invoiceKeyList: [],
        businessNumberList: [],
        invoiceNumberList: []
      };
      const inputVal = this.$refs.byNumberRef.getValue();
      if (inputVal.length > 0) {
        paran[this.downloadForm.numberType] = inputVal;
      }
      if (inputVal.length > 5000) {
        this.$message.warning(this.$t('mdfeTranslate.downloadExceed5000'));
        return;
      }
      getBatchDownloadCteInvoiceInfo(paran).then(res => {
        if (res.code === 200) {
          if (res.data.length === 0) {
            this.$message.error(this.$t('collectionCenter.nullMsg'));
            return;
          }
          res.data.map(item => {
            if (item.cteCreateDate) {
              item.cteCreateDate = this.removeTimezone(item.cteCreateDate);
            }
          });
          this.cteData = res.data;
          this.showDownloadCtePDF = true;
          this.downloadCteXMLKey = new Date().getTime();
          this.showByNumberWindow = false;
        }
      });
    },
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 日期转换
    removeTimezone(dateString) {
      const parts = dateString.split('-');
      const date = parts.slice(0, -1).join('-');
      const dateFormat = date.replace(/-/g, '/');
      return dateFormat.replace(/T/g, ' ');
    },
    // 打开新开CTE发票窗口
    newCteInvoiceShow() {
      this.showNewCteInvoiceWindow = true;
      this.newCteInvoiceKey = new Date().getTime();
    },
    // 关闭新开CTE发票窗口
    closeNewCTEWindow() {
      this.showNewCteInvoiceWindow = false;
      this.getTable();
    },
    // 确定新开CTE发票
    confirmSaveNewData() {
      this.$refs.newCteInvoiceData.submitForm();
    },
    // 确定下载xml
    confirmDownloadXML() {
      const xmlContent = this.rowCteData.xml;
      const blob = new Blob([xmlContent], { type: 'text/xml' }); // 使用 text/xml 类型
      const filename = `cte_${this.rowCteData.invoiceKey}.xml`; // 使用 .xml 后缀

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    // 下载XML
    downloadXml(row) {
      this.rowCteData = row;
      const formatXml = (xmlString) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'application/xml');
        // 格式化节点缩进函数
        const formatNode = (node, indent = 0) => {
          const indentStr = '  '.repeat(indent);
          let result = '';
          if (node.nodeType === Node.ELEMENT_NODE) {
            const children = Array.from(node.childNodes);
            const hasTextOnly = children.every(
              (n) => n.nodeType === Node.TEXT_NODE && !n.textContent.trim()
            );
            result += `${indentStr}<${node.tagName}`;
            // 添加属性
            if (node.attributes.length > 0) {
              for (const attr of node.attributes) {
                result += ` ${attr.name}="${attr.value}"`;
              }
            }
            if (children.length === 0) {
              result += ` />\n`;
            } else if (hasTextOnly) {
              result += `>${node.textContent}</${node.tagName}>\n`;
            } else {
              result += `>\n`;
              for (const child of children) {
                result += formatNode(child, indent + 1);
              }
              result += `${indentStr}</${node.tagName}>\n`;
            }
          } else if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();
            if (text) {
              result += `${indentStr}${text}\n`;
            }
          } else if (node.nodeType === Node.COMMENT_NODE) {
            result += `${indentStr}<!--${node.textContent}-->\n`;
          }
          return result;
        };
        // 提取原始 XML 声明
        const xmlDeclarationMatch = xmlString.match(/<\?xml.*?\?>/);
        const xmlDeclaration = xmlDeclarationMatch ? xmlDeclarationMatch[0] + '\n' : '<?xml version="1.0" encoding="UTF-8"?>\n';
        const formattedContent = formatNode(xmlDoc.documentElement);
        return xmlDeclaration + formattedContent;
      };
      downloadCteXml(row.invoiceKey).then(res => {
        if (res.code === 200) {
          this.rowCteData.xmlString = formatXml(res.data);
          this.rowCteData.xml = res.data;
          this.showDownloadXML = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 关闭单个取消发票弹窗
    closeSingleCancelInvoice() {
      this.cancelInvoiceForm = {
        packageNo: '',
        invoiceKey: '',
        cancelReasonType: null
      };
      this.$refs.cancelInvoiceForm.clearValidate();
      this.showSingleCancelInvoice = false;
    },
    // 确定单个取消发票
    confirmSingleCancelInvoice() {
      this.$refs.cancelInvoiceForm.validate(valid => {
        if (valid) {
          cancelCteInvoice(this.cancelInvoiceForm).then(res => {
            if (res.data.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.getTable();
              this.closeSingleCancelInvoice();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(err => {
            this.$message.error(err.data.msg);
          });
        }
      });
    },
    // 关闭取消发票窗口
    closeCancelWindow() {
      this.showCancelInvoiceWindow = false;
      this.getTable();
    },
    // 确定取消发票
    confirmCancelInvoice() {
      this.$refs.cancelInvoice.confirmSaveData();
    },
    // 打开取消发票弹窗
    openCancelInvoiceWindow(type) {
      if (type === 2) {
        this.showCancelInvoiceWindow = true;
        this.cancelInvoiceWindowKey = new Date().getTime();
      } else {
        this.cancelInvoiceForm.invoiceKey = this.multipleSelection[0].invoiceKey;
        this.cancelInvoiceForm.packageNo = this.multipleSelection[0].businessNumber;
        this.showSingleCancelInvoice = true;
      }
    },
    // 关闭弹窗
    closeWindow() {
      this.showReopenCteInvoiceWindow = false;
      this.getTable();
    },
    // 保存补开cte发票
    confirmSaveData() {
      this.$refs.reopenCteInvoiceData.submitForm();
    },
    // 打开补充cte发票弹窗
    reopenCteInvoiceShow() {
      this.showReopenCteInvoiceWindow = true;
      this.reopenCteInvoiceKey = new Date().getTime();
    },
    // 按业务单号或发票号导出
    onExportusinessOrderNumberInvoiceNumber() {
      this.$refs.exportusinessOrderNumberInvoiceNumberRef.onOpen();
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 单个下载
    checkDetail(row) {
      this.createPdfType = 1;
      const param = {
        invoiceKeyList: [row.invoiceKey]
      };
      getCteInvoiceByKey(param).then(res => {
        if (res.code === 200) {
          if (res.data.length === 0) {
            this.$message.error(this.$t('collectionCenter.nullMsg'));
            return;
          }
          res.data.map(item => {
            if (item.cteCreateDate) {
              item.cteCreateDate = this.removeTimezone(item.cteCreateDate);
            }
          });
          this.cteData = res.data;
          this.showDownloadCtePDF = true;
          this.downloadCteXMLKey = new Date().getTime();
        }
      });
    },
    // 批量下载
    bulkDownload() {
      const invoiceKeys = [];
      this.createPdfType = 2;
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.map(item => {
          invoiceKeys.push(item.invoiceKey);
        });
        const param = {
          invoiceKeyList: invoiceKeys
        };
        getCteInvoiceByKey(param).then(res => {
          if (res.code === 200) {
            if (res.data.length === 0) {
              this.$message.error(this.$t('collectionCenter.nullMsg'));
              return;
            }
            res.data.map(item => {
              if (item.cteCreateDate) {
                item.cteCreateDate = this.removeTimezone(item.cteCreateDate);
              }
            });
            this.cteData = res.data;
            this.showDownloadCtePDF = true;
            this.downloadCteXMLKey = new Date().getTime();
          }
        });
      }
    },
    // 获取查询参数
    getQurey() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      const { type1 } = this;
      const { invoiceIssueTime, businessType, statusList, customerId } = this.queryForm.params;
      const obj = {
        startInvoiceTime: '',
        endInvoiceTime: '',
        invoiceKeyList: [],
        businessNumberList: [],
        customerId,
        businessType,
        statusList
      };
      if (inputVal.length > 0) {
        obj[type1] = inputVal;
      }
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        obj.startInvoiceTime = invoiceIssueTime[0];
        obj.endInvoiceTime = invoiceIssueTime[1];
      }
      return obj;
    },
    getTable() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      if (inputVal.length > 2000) {
        this.$message({
          message: this.$t('orderCenterCont.queried2000pieces'), // 超过2000个字符
          type: 'warning'
        });
        return;
      }
      const obj = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: this.getQurey()
      };
      console.log(obj, '====obj');
      getCteInvoicePage(obj).then(res => {
        const { records, total } = res.data;
        this.total = total;
        this.tableData = records;
      }).catch(err => {
        console.error(err);
      });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTable();
    },
    // 重置
    onReset() {
      this.type1 = 'invoiceKeyList';
      this.listVal = '';
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 10;
      this.queryForm.params = {
        invoiceIssueTime: [startTime, endTime],
        businessType: null,
        invoiceKeyList: [],
        businessNumberList: [],
        customerId: null,
        statusList: null
      };
      this.getTable();
    },
    // 导出
    onExport() {
      if (this.tableData.length > 0) {
        const params = this.getQurey();
        exportCteInvoice(params).then(() => {
          goResourceTaskList();
        }).catch(err => {
          console.error(err);
        });
      } else {
        this.$message.warning(this.$t('operationCenter.noDataExported'));
      }
    },
    // 打开导出NFSeInvoice弹窗
    exportNFSeInvoice() {
      this.$refs.exportNFSe.openExportNFSeInvoice();
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>

<style>
.numberSearch .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
</style>
